module.exports = __webpack_public_path__ + "img/logo6.f7fc96a1.jpg";